import { CRUD_GET_LIST_SUCCESS } from "react-admin";

export default (previousState = null, { type, payload }) => {
  if (type === CRUD_GET_LIST_SUCCESS) {
    //console.log('PAYLOAD', payload)
    return payload.cursors;
  }
  //console.log('PREV', previousState)
  return previousState;
};